<ng-container>
  <div class="tw-flex tw-justify-between">
    <div>
      <h3 class="tw-mt-2 !tw-text-xl !tw-font-light" *ngIf="isDisplayedInCartPage && itemsNo$ | async as itemsNo"
          data-cy="mb-cart-details-list-headline"
          [ngClass]="[isDisplayedInCartPage ? 'font-weight-bolder' : '', 'cart-details-list-headline']"
          aria-label="Cart details list headline">
        {{'mbcart.itemsInYourCart' | cxTranslate :{ items:itemsNo} }}
      </h3>
    </div>
  </div>
  <div *ngIf="purchaseEntries$ | async as purchaseEntries">
    <div *ngIf="purchaseEntries.length > 0">
     <div class="tw-mb-2.5 tw-font-bold">
       <img src="../../../assets/icons/svg/Icon_cart.svg"
         class="mr-1 mb-1 mb-cart-item-icons"
         title="Purchase icon"
         alt="Purchase Icon"
         aria-label="Purchase Icon"
         data-cy="mb-purchase-icon"/>
       {{'mbcart.purchase' | cxTranslate}} ({{purchaseEntries.length}})
      </div>
      <mb-cart-item-list [items]="purchaseEntries"
                         [options]="{isSaveForLater: false, optionalBtn: null}"
                         [isDisplayedInCartPage]="isDisplayedInCartPage"
                         [isCustomerSpecificPrices]="isCustomerSpecificPrices"
                         [showAddToCartButton]="showAddToCartButton"
                         [dataAnalyticsClickSource]="dataAnalyticsClickSource">
      </mb-cart-item-list>
    </div>
  </div>
  <div *ngIf="requestPriceEntries$ | async as requestPriceEntries">
    <div *ngIf="requestPriceEntries.length > 0">
      <div class="tw-mb-2.5 tw-font-bold">
        <img src="../../../assets/icons/svg/icon_request_items.svg"
         class="mr-1 mb-1 mb-cart-item-icons"
         title="Request icon"
         alt="Request Icon"
         aria-label="Request Icon"
         data-cy="mb-request-icon"/>
        {{'mbcart.request' | cxTranslate}} ({{requestPriceEntries.length}})
      </div>
      <mb-cart-item-list [items]="requestPriceEntries"
                         [options]="{isSaveForLater: false, optionalBtn: null}"
                         [isDisplayedInCartPage]="isDisplayedInCartPage"
                         [showAddToCartButton]="showAddToCartButton"
                         [dataAnalyticsClickSource]="dataAnalyticsClickSource">
      </mb-cart-item-list>
    </div>
  </div>
</ng-container>
